import { ReactNode, RefObject, createContext } from "react";
import { useInteractions } from "@floating-ui/react";

// TEXT

// STYLES

// DATA

// TYPES
export type Props = {
  children: ReactNode;
  elementsRef: RefObject<Array<HTMLElement | null>>;
  labelsRef?: RefObject<Array<string | null>>;
  activeIndex: number | null;
  getItemProps: ReturnType<typeof useInteractions>["getItemProps"];
};

type GetItemProps = ReturnType<typeof useInteractions>["getItemProps"];

export type ItemContextValue = {
  activeIndex: number | null;
  getItemProps: GetItemProps;
} | null;

// CONSTANTS
export const ItemContext = createContext<ItemContextValue>(null);

// FUNCTIONS

// ASSETS
